<template>
  <div>
    <v-container>
      <v-btn
        class="tagBtn"
        @click="currentView = 'tags-management'"
        depressed
        :outline="currentView != 'tags-management'"
        :color="currentView == 'tags-management' ? 'primary' : 'grey'"
      >
        {{ $t('Tags Management') }}
      </v-btn>
      <v-btn
        class="tagBtn"
        @click="currentView = 'status-management'"
        depressed
        :outline="currentView != 'status-management'"
        :color="currentView == 'status-management' ? 'primary' : 'grey'"
      >
        {{ $t('Status Management') }}
      </v-btn>
    </v-container>
    <component :is="currentView"></component>
  </div>
</template>

<script>
import TagsManagement from './TagsManagement'
import StatusManagement from './StatusManagement'
export default {
  components: {
    TagsManagement,
    StatusManagement
  },
  data() {
    return {
      currentView: 'tags-management'
    }
  }
}
</script>

<style lang="scss" scoped>
.tagBtn{
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/analytics/TagsAndStatus.vue